jQuery(document).ready(function ($) {
	// Oct 2026 QA: each news slider uses the arrows in its own section. Previously the
	// selector was global, so the "Monitor and manage" arrows also drove the news slider.
	$(".news-slider").each(function () {
		const $section = $(this).closest("section");
		$(this).slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		speed: 500,
		adaptiveHeight: false,
		cssEase: "cubic-bezier(0.77, 0, 0.175, 1)",
		prevArrow: $section.find(".news-prev"),
		nextArrow: $section.find(".news-next"),
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
				},
			},
		],
		});
	});

	//Logo slider
	$(".icon-logo-block").each(function () {
		const $block = $(this);
		const $slider = $block.find(".icon-slider");
		var sliderSpeed = parseInt($slider.data("speed")) || 8000;
		$slider.slick({
			autoplay: true,
			autoplaySpeed: 0,
			speed: sliderSpeed,
			arrows: false,
			swipe: false,
			slidesToShow: 8,
			cssEase: "linear",
			pauseOnFocus: false,
			pauseOnHover: false,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					},
				},
			],
		});
	});

	//Quote
	$(".quote-slider").slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		speed: 500,
		adaptiveHeight: false,
		cssEase: "cubic-bezier(0.77, 0, 0.175, 1)",
		prevArrow: $(".quote-prev"),
		nextArrow: $(".quote-next"),
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	});

	//Content slider
	$(".content-slider-block").each(function () {
		const $block = $(this);

		$block.find(".slider").slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			dots: true,
			speed: 600,
			adaptiveHeight: true,
			cssEase: "ease",

			prevArrow: $block.find(".content-prev"),
			nextArrow: $block.find(".content-next"),

			appendDots: $block.find(".content-slider-dots"),

			customPaging: function () {
				return '<button class="w-3 h-3 rounded-full bg-neutral-300 transition-all"></button>';
			},
			responsive: [
				{
					breakpoint: 768,
					settings: {
						arrows: false,
					},
				},
			],
		});
	});

	//home-benefit-block
	$(".home-benefit-block").each(function () {
		const $block = $(this);

		$block.find(".slider").slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 3000,
			speed: 1000,
			fade: true,
			cssEase: "cubic-bezier(0.77, 0, 0.175, 1)",
			pauseOnHover: false,
			pauseOnFocus: false,
			adaptiveHeight: true,
		});
	});

	//testimonial-block
	$(".testimonial-block").each(function () {
		const $block = $(this);

		$block.find(".slider").slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			dots: false,
			speed: 500,
			adaptiveHeight: true,
			cssEase: "cubic-bezier(0.77, 0, 0.175, 1)",
			prevArrow: $block.find(".testi-prev"),
			nextArrow: $block.find(".testi-next"),
		});
	});

	// Header mega-menu submenu slider (one per menu item, unique class per instance)
	$("[class*='menu-slider-']").each(function () {
		const $slider = $(this);
		const $submenu = $slider.closest(".submenu");

		$slider.slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			dots: false,
			speed: 500,
			adaptiveHeight: false,
			cssEase: "cubic-bezier(0.77, 0, 0.175, 1)",
			prevArrow: $submenu.find(".sub-prev"),
			nextArrow: $submenu.find(".sub-next"),
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		});
	});

	// tracking-block (mobile only)
	$(".tracking-block").each(function () {
		const $block = $(this);
		const $slider = $block.find(".mobile-slider");

		function initTrackingSlider() {
			if ($slider.hasClass("slick-initialized")) return;

			$slider.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				arrows: true,
				dots: false,
				speed: 500,
				adaptiveHeight: false,
				cssEase: "cubic-bezier(0.77, 0, 0.175, 1)",
				prevArrow: $block.find(".news-prev"),
				nextArrow: $block.find(".news-next"),
			});
		}

		function destroyTrackingSlider() {
			if ($slider.hasClass("slick-initialized")) {
				$slider.slick("unslick");
			}
		}

		function checkMobile() {
			// Oct 2026 QA: < 768 to match Tailwind's md breakpoint - at exactly 768px the slider
			// started but its arrows (md:hidden) were hidden, so it looked stuck.
			if (window.innerWidth < 768) {
				initTrackingSlider();
			} else {
				destroyTrackingSlider();
			}
		}

		checkMobile();
		$(window).on("resize", checkMobile);
	});
});
